export const statusOptions = {
  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
  "Action Needed": [
    {
      title: "View Details",
      cls: "viewDetails",
      icon: "chevron-right",
      disabled:false
    },
    {
      title: "Mark as In Progress",
      cls: "markInProgress",
      icon: "chevron-right",
      disabled:false
    },
    {
      title: "Mark as Dismissed",
      cls: "markDismissed",
      icon: "chevron-right",
      disabled:false
    }
  ],
  "In Progress": [
    {
      title: "View Details",
      cls: "viewDetails",
      icon: "chevron-right",
      disabled:false
    },
    {
      title: "Mark as In Progress",
      cls: "markInProgress",
      icon: "chevron-right",
      disabled:true
    },
    {
      title: "Mark as Dismissed",
      cls: "markInProgress",
      icon: "chevron-right",
      disabled:true
    }
  ],
  "Dismissed": [
    {
      title: "View Details",
      cls: "viewDetails",
      icon: "chevron-right",
      disabled:false
    },
    {
      title: "Mark as In Progress",
      cls: "markInProgress",
      icon: "chevron-right",
      disabled:false
    },
    {
      title: "Mark as Dismissed",
      cls: "markDismissed",
      icon: "chevron-right",
      disabled:true
    }
  ],
};



// WEBPACK FOOTER //
// ./src/pages/notificationAlerts/stores/statusOptions.js